'use client';
import type React from 'react';
import { createContext, useContext, useMemo } from 'react';
import { MediaType } from '@/helpers/enums';
import { useGetCommonStore } from '@/store';
import { useCurrentMediaType } from './hooks';

export interface IResponsiveContext {
  currentMediaType: MediaType;
}

const ResponsiveContext = createContext<IResponsiveContext | null>(null);

export function ResponsiveProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const currentMediaType = useCurrentMediaType();
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const defaultMediaType = isMobileDevice
    ? MediaType.MOBILE_S
    : MediaType.DESKTOP;

  const contextValue = useMemo(
    () => ({ currentMediaType: currentMediaType ?? defaultMediaType }),
    [currentMediaType, defaultMediaType]
  );

  return (
    <ResponsiveContext.Provider value={contextValue}>
      {children}
    </ResponsiveContext.Provider>
  );
}

export function useResponsive() {
  const resposiveContext = useContext(ResponsiveContext);

  if (!resposiveContext) {
    throw new Error('useResponsive must be used within a ResponsiveProvider');
  }

  return resposiveContext;
}
